@if (definition) {
  <div class="row" [class.reverse]="definition.value.alignment == 'reversed'">
    <div class="col-xs-12 col-lg-7">
      <div class="inner {{ definition.value.left_image ? 'hasimage' : 'noimage'}}" [ngStyle]="getStyleLeft()">
        @if (definition.value.left_image) {
          <wagtail-page-element-image
            [image]="definition.value.left_image"
            [width]="1200"
            [height]="660"
            [sizes]="leftImageSizes"
          ></wagtail-page-element-image>
        }
        @if (definition.value.left_color == 'white') {
          <div class="backdrop-70"></div>
        }
        <div class="text">
          <div class="title">{{ definition.value.left_title }}</div>
          <div class="body">{{ definition.value.left_text }}</div>
          @if (definition.value.left_button_text) {
            @if (leftButtonDefinition) {
              <wagtail-page-element-button
                [definition]="leftButtonDefinition"
              ></wagtail-page-element-button>
            } @else {
              {{ definition.value.left_button_text }}
            }
          }
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-5">
      <div class="inner {{ definition.value.right_image ? 'hasimage' : 'noimage'}}" [ngStyle]="getStyleRight()">
        @if (definition.value.right_image) {
          <wagtail-page-element-image
            [image]="definition.value.right_image"
            [width]="800"
            [height]="660"
            [sizes]="rightImageSizes"
          ></wagtail-page-element-image>
        }
        @if (definition.value.right_color == 'white') {
          <div class="backdrop-70"></div>
        }
        <div class="text">
          <div class="title">{{ definition.value.right_title }}</div>
          <div class="body">{{ definition.value.right_text }}</div>
          @if (definition.value.right_button_text) {
            @if (rightButtonDefinition) {
              <wagtail-page-element-button
                [definition]="rightButtonDefinition"
              ></wagtail-page-element-button>
            } @else {
              {{ definition.value.right_button_text }}
            }
          }
        </div>
      </div>
    </div>
  </div>
}
